import { media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

import { FieldDirection } from '../ControlsPanel';
import { GroupSize } from '../ControlsPanel/controlGroupsData';

type WrapperProps = {
  flow: FieldDirection;
  size: GroupSize;
};

const wrapperHalfResponsive = media.phone`
  width: calc(50% - 6.5px);
`;

const flowVariants: { [key in FieldDirection]: ReturnType<typeof css> } = {
  horizontal: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    > * {
      ${wrapperHalfResponsive};
    }
  `,
  vertical: css`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  `
};

const sizeVariants: { [key in GroupSize]: ReturnType<typeof css> } = {
  full: css`
    width: 100%;
    > * {
      flex-grow: 0;
    }
  `,
  half: css`
    width: 50%;
    max-width: 190px;
    display: flex;
    flex-direction: column;
    ${wrapperHalfResponsive};
  `
};
const fourthRowOnMobiles = media.tablet`
  align-items: flex-start;
  & > * {
    width: auto;
  }
`;

const Wrapper = styled.div<WrapperProps>`
  ${({ flow }) => flowVariants[flow]}
  ${({ size }) => sizeVariants[size]}
  
  &:not(:last-of-type) {
    margin-bottom: 19px;
  }

  &:nth-of-type(3) {
    margin-bottom: 20px;
  }
  &:nth-of-type(4) {
    margin-bottom: 10px;
    align-items: flex-end;
    align-self: flex-start;

    & > * {
      width: 170px;
    }

    span {
      margin-bottom: 6px;
    }

    ${fourthRowOnMobiles}
  }
  a {
    color: var(--blue_100);
  }

  input[type='text'] {
    max-width: 130px;
  }

  &:nth-of-type(5) {
    & > span {
      margin-bottom: 18px;
    }
  }
`;

const controlGroupSubtitlePhone = media.phone`
  font-size: 14px;
  line-height: 17px;
`;

export const ControlGroupSubtitle = styled.span<Partial<WrapperProps>>`
  display: block;
  font-size: 14px;
  line-height: 17px;
  color: #919eaa;
  letter-spacing: 0.01em;

  margin: ${({ flow }) => (flow === 'horizontal' ? '0 ' : '0 0 17px 0')};
  width: ${({ flow }) => (flow === 'horizontal' ? 'auto ' : '100%')};
  ${controlGroupSubtitlePhone};
`;

export default Wrapper;
